// userbox.js

/* globals $ */
$(function () {
	'use strict';

	var $userBox = $('#scs-pageheader-userbox');

	if (!$userBox.length) {
		return;
	}

	// Ensure expected data attributes are defined to avoid errors (DAC-15301)
	if ($userBox.data('login-url') === undefined) { $userBox.data('login-url', ''); }
	if ($userBox.data('logout-url') === undefined) { $userBox.data('logout-url', ''); }

	var currentPage = encodeURIComponent(location.href),
		loginUrl = $userBox.data('login-url').replace(/originUrl=[^&]*/, 'originUrl=' + currentPage),
		$logoutButton = $userBox.find('#scs-pageheader-userbox-logout-button'),
		logoutUrl,
		logoutButtonUrl;

	// update originUrl and RURL to point to current page (except for pex logout URL)
	// (otherwise they would point to the responsive-header config page, due to SSI cached header)
	$userBox.data('login-url', loginUrl);
	if (!$userBox.data('is-pex')) {
		logoutUrl = $userBox.data('logout-url').replace(/RURL=[^&]*/, 'RURL=' + currentPage);
		logoutButtonUrl =($logoutButton.attr('href') || '').replace(/RURL=[^&]*/, 'RURL=' + currentPage);

		$userBox.data('logout-url', logoutUrl);
		$logoutButton.attr('href', logoutButtonUrl);
	} else {
		//update domain for PEX

		var getRurl = function (url) {
			var result = /RURL=([^&]*)/.exec(url);
			if (result && result.length === 2) {
				return decodeURIComponent(result[1]);
			}
			return false;
		}

		var getHost = function (url) {
			var aTag = $('<a />', {href: url})[0];
			return aTag.protocol + '//' + aTag.host;
		}

		var logoutUrlRurl = getRurl($userBox.data('logout-url')),
			logoutButtonRurl = getRurl($logoutButton.attr('href')),
			currentHost = getHost(location.href);

		if (logoutUrlRurl && currentHost !== getHost(logoutUrlRurl)) {
			logoutUrlRurl = logoutUrlRurl.replace(getHost(logoutUrlRurl), currentHost);
			logoutUrl = $userBox.data('logout-url').replace(/RURL=[^&]*/, 'RURL=' + encodeURIComponent(logoutUrlRurl));
			$userBox.data('logout-url', logoutUrl);
		}

		if (logoutButtonRurl && currentHost !== getHost(logoutButtonRurl)) {
			logoutButtonRurl = logoutButtonRurl.replace(getHost(logoutButtonRurl), currentHost);
			logoutButtonUrl = $userBox.data('logout-url').replace(/RURL=[^&]*/, 'RURL=' + encodeURIComponent(logoutButtonRurl));
			$logoutButton.attr('href', logoutButtonUrl);
		}

	}


	// clear the mini basket's item count (cart-itemcount) on logout
	$logoutButton.click(function () {
		$.cookie('SCSMiniShoppingCart', '', {
			'path': '/'
		});
		$('#shoppingCartLink .cart-itemcount').remove();
		return true;
	});
});



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/userbox.js
// module id = 357
// module chunks = 0